/* Theme-owned entrance animation. Source contract: ../pulse-source-review.json.
 * Reinitialization is allowed; there is deliberately no permanent played flag.
 */
(function installNativeRelatedPulse() {
  'use strict';

  // Several native sections may include this asset. Register lifecycle hooks once.
  if (window.NativeRelatedPulse) return;

  const selector = '[data-native-related-entry]';
  const visibleRatio = 0.25;
  const animatedClass = 'np-related-animated';
  const currentState = new WeakMap();

  function cancelPreviousState(element) {
    const previous = currentState.get(element);
    if (!previous) return;
    if (previous.observer) previous.observer.unobserve(element);
    previous.cleanupTimers.forEach(timer => window.clearTimeout(timer));
    previous.cleanupTimers.clear();
  }

  function play(element, animation, state) {
    if (currentState.get(element) !== state) return;
    element.style.visibility = 'visible';
    element.classList.add(animatedClass, animation);
    element.onanimationend = function onAnimationEnd() {
      if (currentState.get(element) !== state) return;
      const timer = window.setTimeout(function removeAnimatedClass() {
        state.cleanupTimers.delete(timer);
        if (currentState.get(element) === state) {
          element.classList.remove(animatedClass);
        }
      }, 2000);
      state.cleanupTimers.add(timer);
    };
  }

  function isVisibleEnough(entry) {
    if (!entry.isIntersecting) return false;
    const rootHeight = entry.rootBounds
      ? entry.rootBounds.height
      : window.innerHeight;
    return entry.intersectionRatio >= visibleRatio ||
      entry.boundingClientRect.height * visibleRatio > rootHeight;
  }

  function init(root = document) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    const elements = Array.from(root.querySelectorAll(selector));
    if (typeof root.matches === 'function' && root.matches(selector)) {
      elements.unshift(root);
    }
    const observers = new Map();

    elements.forEach(function initializeElement(element) {
      const animation = element.getAttribute('data-native-related-entry');
      if (!animation) return;
      cancelPreviousState(element);

      const state = { observer: null, cleanupTimers: new Set() };
      currentState.set(element, state);
      if (animation.toLowerCase().includes('in')) {
        element.style.visibility = 'hidden';
      }

      if (!window.IntersectionObserver) {
        play(element, animation, state);
        return;
      }

      const offset = Number(element.getAttribute('data-native-related-offset')) || 0;
      let observer = observers.get(offset);
      if (!observer) {
        observer = new window.IntersectionObserver(function handleIntersections(entries, activeObserver) {
          entries.forEach(function handleEntry(entry) {
            const activeState = currentState.get(entry.target);
            if (!activeState || activeState.observer !== activeObserver) return;
            if (!isVisibleEnough(entry)) return;
            play(entry.target, entry.target.getAttribute('data-native-related-entry'), activeState);
            activeObserver.unobserve(entry.target);
            activeState.observer = null;
          });
        }, {
          threshold: [0, visibleRatio],
          rootMargin: `0px 0px ${-offset}px 0px`
        });
        observers.set(offset, observer);
      }
      state.observer = observer;
      observer.observe(element);
    });
  }

  window.NativeRelatedPulse = { init };
  document.addEventListener('shopify:section:load', function onSectionLoad(event) {
    init(event.target);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }
})();
